import React from 'react';
import { Modal } from 'antd';
import { isNil } from 'lodash';

import './style.scss';

const PureModal = props => {
  const {
    closeable,
    maskClosable,
    bodyStyle,
    maskStyle,
    visible,
    handleClose,
    children
  } = props;

  return (
    <Modal
      centered
      title={null}
      footer={null}
      visible={visible}
      wrapClassName="pure-modal"
      maskStyle={maskStyle || {}}
      maskClosable={maskClosable || true}
      bodyStyle={{ padding: 0, ...bodyStyle }}
      onCancel={handleClose ? handleClose : () => {}}
      closeIcon={
        <span
          className={`light xlarge-font line-color ${
            closeable || isNil(closeable) ? 'block' : 'hidden'
          }`}>
          ✕
        </span>
      }>
      {children}
    </Modal>
  );
};

export default PureModal;
